import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20film%20theater%20interior%20with%20dramatic%20red%20curtains%20and%20stage%20lights%2C%20warm%20golden%20spotlight%20effects%20on%20dark%20elegant%20background%2C%20luxury%20cinema%20hall%20atmosphere%20with%20velvet%20textures%2C%20professional%20theater%20photography&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
          alt={siteConfig.name}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/15 mb-6">
            <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
            <span className="text-sm text-background-50/90">汇聚各大视频平台优质资源</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            聚精彩视频，享<span className="text-accent-400">无限可能</span>
          </h1>
          <p className="text-base md:text-lg text-background-200/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            妖精视频 · 桃花视频 · 苹果视频 · 榴莲视频 —— 一站聚合，高清免费在线观看。
            影视大全、热门剧集、综艺娱乐、动漫动画，应有尽有。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/yingshidaquan"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-film-line mr-2"></i>探索影视大全
            </Link>
            <Link
              to="/category/remenjuji"
              className="px-8 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/20 font-medium rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-fire-line mr-2"></i>热门剧集推荐
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}